import { render, staticRenderFns } from "./LogisticCostPerActivityCard.vue?vue&type=template&id=1b11d5d2&scoped=true&"
import script from "./LogisticCostPerActivityCard.vue?vue&type=script&lang=js&"
export * from "./LogisticCostPerActivityCard.vue?vue&type=script&lang=js&"
import style0 from "./LogisticCostPerActivityCard.vue?vue&type=style&index=0&id=1b11d5d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b11d5d2",
  null
  
)

export default component.exports